import React from "react";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import Typography from "@mui/material/Typography";
import { PremiumUploadPlayTestImageComponent, UploadImageComponent } from "./UploadPlayTestImageComponent";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestId} props.playTestId
 */
export default function AddPlayTestPhotoFullScreenDialog({ gameId, playTestId }) {
  const { data: entitlements } = useMyEntitlements();

  const hasLargeFileUploads = entitlements && entitlements.hasLargeFileUploads;

  return (
    <FullScreenDialog title="Add Play Test Photo" canSave={true}>
      {hasLargeFileUploads ? (
        <PremiumUploadPlayTestImageComponent gameId={gameId} playTestId={playTestId} />
      ) : (
        <UploadImageComponent gameId={gameId} playTestId={playTestId} />
      )}
      <Typography variant="body2" textAlign="right" color="text.secondary">
        Maximum file size: {hasLargeFileUploads ? "500MB" : "5MB"}
      </Typography>
    </FullScreenDialog>
  );
}
